import React, { useState, useRef, useEffect } from 'react';
import Select, { components } from 'react-select';
import services from '../../services';
import { useParams } from 'react-router-dom';

const StatusDropdown = ({
    item,
    StatusFields = [],
    handleUpdateCell,
    handleUpdatedCustomField,
    deleteCustomField,
    getDefaultColorByValue,
    statusColors,
    setCustomeFieldId,
    customeFiedId,
    filterStatusVal,
    handletaskUpdate,
    customprokey,
    setCustomprokey,
    triggerTaskUpdate,
    setTriggerTaskUpdate,
    updateCustomProKey,
    selectedStatus,
    setSelectedStatus,
    selectedFieldId,
    handleStatusClick,
    idx,
    getAllProperty,
    getPropertyByID,
    getAllPropertyByTaskId,
}) => {
    const [selectedStatusColor, setSelectedStatusColor] = useState(null);
    const [inputStatusEditValue, setInputStatusValue] = useState('');
    const [showOptionModal, setShowOptionModal] = useState(null);
    const [selecteStatusIndex, setSelecteStatusIndex] = useState(null);
    const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
    const [hoveredId, setHoveredId] = useState(null);
    const modalRef = useRef(null);
    const { id } = useParams();
    const [menuOpen, setMenuOpen] = useState(true);
    const [statusOptions, setStatusOptions] = useState(
        StatusFields.map((status) => ({
            value: status?.customField?.value,
            label: status?.customField?.value,
            color: status?.customField?.color || getDefaultColorByValue(status?.customField?.value),
            id: status.id,
            index: status.index,
        }))
    );
    const [isDragging, setIsDragging] = useState(false);

    const customStyles = {
        control: (base) => ({
            ...base,
            borderRadius: 8,
            boxShadow: '0 2px 8px #0001',
            border: '1px solid #ccc',
            minHeight: 38,
            fontSize: 14,
        }),
        option: (base, { isFocused }) => ({
            ...base,
            backgroundColor: isFocused ? '#f0f0f0' : '#fff',
            color: '#000',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        }),
        singleValue: (base) => ({
            ...base,
            display: 'flex',
            alignItems: 'center',
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    };
    const [draggingIndex, setDraggingIndex] = useState(null);

const DraggableMenuList = (props) => {
    const { selectProps } = props;
    const {
        statusOptions,
        setStatusOptions,
        item,
        getAllProperty,
        getPropertyByID,
        getAllPropertyByTaskId,
        setHoveredId,
        hoveredId,
        setModalPosition,
        setShowOptionModal,
        setInputStatusValue,
        setCustomeFieldId,
        setSelecteStatusIndex,
        setSelectedStatusColor
    } = selectProps;

    const [dragIndex, setDragIndex] = useState(null);
    const isDraggingRef = useRef(false);

    const handleDrop = async (event, dropIndex) => {
        event.preventDefault();
        if (dragIndex === null || dragIndex === dropIndex) return;

        const draggedOption = statusOptions[dragIndex];

        // API call
        await services.customfield.UPDATE_CUSTOM_FIELD(draggedOption.id, {
            customPropertyId: item.id,
            index: dropIndex,
        });

        // reorder options
        const newStatusOptions = [...statusOptions];
        newStatusOptions.splice(dragIndex, 1);
        newStatusOptions.splice(dropIndex, 0, draggedOption);

        setStatusOptions(
            newStatusOptions.map((opt, i) => ({ ...opt, index: i }))
        );

        setDragIndex(null);
        isDraggingRef.current = false;
        selectProps.setIsDragging(false);

        await getAllProperty(item.id);
        await getPropertyByID(item?.boardId);
        await getAllPropertyByTaskId(item?.taskId);
    };

    return (
        <components.MenuList {...props}>
            {statusOptions.map((opt, index) => (
                <div
                    onMouseDown={(e) => e.stopPropagation()}
                    key={opt.id}
                    draggable
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => handleDrop(e, index)}
                    onDragStart={(e) => {
                        setDragIndex(index);
                        isDraggingRef.current = true;
                        selectProps.setIsDragging(true);
                        e.dataTransfer.effectAllowed = "move";
                    }}
                    onDragEnd={() => {
                        setDragIndex(null);
                        isDraggingRef.current = false;
                        selectProps.setIsDragging(false);
                    }}
                    onClick={() => {
                        if (!isDraggingRef.current) {
                            // Toggle selection: add if not selected, remove if already selected
                            const currentSelected = selectProps.value || [];
                            const isAlreadySelected = currentSelected.some(f => f.id === opt.id);
                            const newSelected = isAlreadySelected
                                ? currentSelected.filter(f => f.id !== opt.id)
                                : [...currentSelected, opt];
                            selectProps.onChange(newSelected);
                        }
                    }}
                    onMouseEnter={() => setHoveredId(opt.id)}
                    onMouseLeave={() => setHoveredId(null)}
                    style={{
                        padding: "8px 12px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: "#fff",
                        borderBottom: "1px solid #eee",
                        cursor: "grab",
                    }}
                >
                    {/* LEFT LABEL */}
                    <span
                        style={{
                            backgroundColor: opt.color,
                            color: "#fff",
                            padding: "2px 8px",
                            borderRadius: 4,
                            fontSize: 13,
                        }}
                    >
                        {opt.label}
                    </span>

                    {/* RIGHT ACTIONS */}
                    <div className="flex items-center gap-2">
                        {hoveredId === opt.id && (
                            <i
                                className="bi bi-sliders text-gray-500 cursor-pointer"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const rect = e.currentTarget.getBoundingClientRect();
                                    setModalPosition({
                                        top: rect.bottom + window.scrollY,
                                        left: rect.left + window.scrollX,
                                    });
                                    setShowOptionModal(opt.id);
                                    setInputStatusValue(opt.label);
                                    setCustomeFieldId(opt.id);
                                    setSelecteStatusIndex(opt.index);
                                    setSelectedStatusColor(opt.color);
                                }}
                            />
                        )}

                        {/* DRAG HANDLE */}
                        <span
                            onMouseDown={(e) => e.stopPropagation()}
                            style={{
                                width: 16,
                                cursor: "grab",
                                fontSize: 14,
                                color: "#999",
                            }}
                        >
                            ⋮⋮
                        </span>
                    </div>
                </div>
            ))}
        </components.MenuList>
    );
};









    useEffect(() => {
        setStatusOptions(
            StatusFields.map((status) => ({
                value: status?.customField?.value,
                label: status?.customField?.value,
                color: status?.customField?.color || getDefaultColorByValue(status?.customField?.value),
                id: status.id,
                index: status.index,
            }))
        );
    }, [StatusFields]);




    useEffect(() => {
        const handleMouseDownOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setShowOptionModal(null);
            }
        };
        document.addEventListener('mousedown', handleMouseDownOutside);
        return () => {
            document.removeEventListener('mousedown', handleMouseDownOutside);
        };
    }, []);

    function filterObjectsByIds(idArray, objectArray) {
        return objectArray.filter(obj => idArray.includes(obj.id));
    }

    const formattedTagNew = filterObjectsByIds(selectedFieldId, statusOptions);

    const dropdownComponents = React.useMemo(() => ({
        MenuList: DraggableMenuList
    }), []);

    const formatOptionLabel = React.useCallback((data) => (
        <div className="flex items-center justify-between w-full overflow-y-auto">
            <span
                className="inline-flex items-center rounded px-2 py-0.5 mr-1 text-[13px] font-medium"
                style={{
                    backgroundColor: data.color,
                    color: 'white',
                }}
            >
                {data.label}
            </span>
        </div>
    ), []);

    return (
        <div className="relative z-[999]">

            <Select
                options={statusOptions}
                styles={customStyles}
                placeholder="Select status"
                isMulti
                isClearable={false}
                hideSelectedOptions={false}
                formatOptionLabel={formatOptionLabel}
                value={formattedTagNew}
                components={dropdownComponents}
                menuShouldScrollIntoView={false}
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                closeMenuOnSelect={false}
                setIsDragging={setIsDragging}
                statusOptions={statusOptions}
                setStatusOptions={setStatusOptions}
                item={item}
                getAllProperty={getAllProperty}
                getPropertyByID={getPropertyByID}
                getAllPropertyByTaskId={getAllPropertyByTaskId}
                setHoveredId={setHoveredId}
                hoveredId={hoveredId}
                setModalPosition={setModalPosition}
                setShowOptionModal={setShowOptionModal}
                setInputStatusValue={setInputStatusValue}
                setCustomeFieldId={setCustomeFieldId}
                setSelecteStatusIndex={setSelecteStatusIndex}
                setSelectedStatusColor={setSelectedStatusColor}
                menuIsOpen={menuOpen || isDragging}
                onMenuOpen={() => setMenuOpen(true)}
                onChange={(selectedOptions) => {
                    const options = Array.isArray(selectedOptions) ? selectedOptions : [];
                    setSelectedStatus(options);
                    updateCustomProKey(item, null, options);
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        handleUpdateCell(item, e.target.value, 'grey', '');
                    }
                }}
                menuPlacement="auto"
                onMenuClose={() => setMenuOpen(false)}
                handleUpdatedCustomField={handleUpdatedCustomField}
            />
            {statusOptions.map((status) => {
                const isModalOpen = showOptionModal === status.id;
                if (!isModalOpen) return null;
                return (
                    <div
                        key={status.id}
                        ref={modalRef}
                        className="fixed z-50 w-64 bg-white border border-gray-300 shadow-lg rounded p-4"
                        style={{
                            top: `${modalPosition.top}px`,
                            transform: "translate(0px, -50px)"
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex justify-between items-center mb-2">
                            <h3 className="text-sm font-semibold">Option details</h3>
                            <i
                                className="bi bi-trash text-black-500 cursor-pointer"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    deleteCustomField(customeFiedId, '', status);

                                }}
                            />
                        </div>

                        <input
                            type="text"
                            className="w-full border border-black rounded px-2 py-1 text-sm mb-3"
                            value={inputStatusEditValue}
                            onChange={(e) => setInputStatusValue(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                        />

                        <div className="text-sm font-medium mb-2 text-black">Colors</div>

                        <div className="grid grid-cols-5 gap-2">
                            {statusColors.map((color) => (
                                <div
                                    key={color}
                                    className="w-6 h-6 rounded-full cursor-pointer relative flex items-center justify-center"
                                    style={{ backgroundColor: color }}
                                    onClick={() => setSelectedStatusColor(color)}
                                >
                                    {selectedStatusColor === color && (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="w-4 h-4 text-white"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            strokeWidth={3}
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                        </svg>
                                    )}
                                </div>
                            ))}
                        </div>

                        <div className="flex justify-end gap-2 mt-3">
                            <button
                                className="text-xs  text-white px-3 py-1.5 rounded-md hover:bg-blue-600 transition-colors"
                                onClick={() => {
                                    setShowOptionModal(null);
                                    handleUpdatedCustomField(item, inputStatusEditValue, selectedStatusColor);
                                }}

                                style={{ backgroundColor: 'rgb(22, 96, 200)' }}
                            >
                                Save
                            </button>
                            <button
                                className="text-xs bg-gray-200 text-gray-700 px-3 py-1.5 rounded-md hover:bg-gray-300 transition-colors"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    setShowOptionModal(null);
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default StatusDropdown;
